function copyEmbedCode(event, clicked) {
    event.preventDefault();
    let copyText = jQuery(clicked).siblings("p.code:first").select();
    let range = document.createRange();
    range.selectNodeContents(copyText[0]);
    let selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
}
